import * as TYPES from './types';
export default {
    [TYPES.SET_RESULT](state, payload) {
        state.result = payload;
    },
    [TYPES.SET_WAITING](state, payload) {
        state.waiting = payload;
    },
    [TYPES.SET_PAGE_INDEX](state, payload) {
        state.pageIndex = payload;
    }
};
